export default "__VITE_ASSET__B0hG54xD__"